export interface IconConfig {
  iconsBasePath: string;
  icons: string[];
  images: string[];
  logos: string[];
  social: string[];
  integrations: ['greenhouse-add', 'greenhouse-assigned'];
}

export const ICON_CONFIG: IconConfig = {
  iconsBasePath: 'assets/icons/',
  icons: [
    'fire_red',
    'mojo-business-center',
    'happy',
    'super-happy',
    'crying',
    'application-history',
    'speach-bubble',
    'sort',
  ],
  images: [
    'homepage-empty-search',
    'homepage-empty-state',
    'advanced-candidates-empty-state',
    'rejected-candidates-empty-state',
  ],
  logos: [],
  social: [
    'crunchbase',
    'facebook',
    'github',
    'instagram',
    'linkedin',
    'pinterest',
    'twitter',
    'youtube',
    'greenhouse',
    'oracle',
  ],
  integrations: ['greenhouse-add', 'greenhouse-assigned'],
};

export enum Icons {
  fireRed = 'fire-red',
  shortlistCandidate = 'forward',
  happy = 'happy',
  superHappy = 'super-happy',
  crying = 'crying',
}
